import { ServiceHM } from '../types/service.type';

export const GET_SERVICE_REQUEST = "/product/service/get"

export interface ServiceRequest {
    url: string;
}

export interface ServiceResponse {
    service: ServiceHM;
}